module.exports = __webpack_public_path__ + "static/media/christmas decoration.33bb6ab1.png";